import React from "react";
import { Reveal } from "../motion/Reveal";
import { ArrowUpRight } from "lucide-react";
import LogoMark from "./LogoMark";

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
  else el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Footer() {
  return (
    <footer className="bg-[#222222] text-[#FAFAFA] pt-24 pb-10 border-t border-[#9A9A9A]/12" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <Reveal>
          <div className="flex items-end gap-6 mb-16">
            <img
              src="/brand/logo.png"
              alt="DB Computronics"
              className="w-[120px] h-[120px] sm:w-[160px] sm:h-[160px] lg:w-[220px] lg:h-[220px] rounded-xl object-contain shadow-[0_20px_60px_-20px_rgba(0,0,0,0.55)]"
              data-testid="footer-logo"
            />
            <div className="font-display leading-[0.85] tracking-[-0.04em] text-[#FAFAFA] text-[64px] sm:text-[110px] lg:text-[180px]">
              Computronics<span className="text-[#A4161A]">.</span>
            </div>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 border-t border-[#9A9A9A]/15 pt-14">
          <div className="md:col-span-5">
            <div className="section-label mb-4">DB Computronics</div>
            <p className="font-body text-[#9A9A9A] text-[14px] leading-relaxed max-w-[38ch]">
              Enterprise IT solutions for corporates, manufacturers, hospitals, banks and
              government institutions across India. Since 2000.
            </p>
            <div className="mt-8 flex items-center gap-3">
              <a
                href="mailto:info@dbcomputronics.in"
                className="btn-red inline-flex items-center gap-2 px-5 py-3 rounded-lg font-btn text-[11px] tracking-[0.22em] uppercase"
                data-testid="footer-email-cta"
              >
                <span>info@dbcomputronics.in</span>
                <ArrowUpRight size={14} className="relative z-10" />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="section-label mb-4 !text-[#9A9A9A]">Navigate</div>
            <ul className="space-y-3 font-body text-[14px]">
              {[
                ["Solutions", "#solutions"],
                ["Industries", "#industries"],
                ["Brands", "#brands"],
                ["Why Us", "#why"],
                ["Testimonials", "#testimonials"],
                ["Contact", "#contact"],
              ].map(([l, h]) => (
                <li key={h}>
                  <button
                    onClick={() => scrollTo(h)}
                    className="text-[#FAFAFA]/80 hover:text-[#A4161A] transition-colors duration-300"
                    data-testid={`footer-nav-${l.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {l}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="section-label mb-4 !text-[#9A9A9A]">Reach Us</div>
            <ul className="space-y-3 font-body text-[14px] text-[#FAFAFA]/85">
              <li>
                <a href="tel:+919963645702" className="red-underline">+91 99636 45702</a>
              </li>
              <li>
                <a href="tel:+919290305011" className="red-underline">+91 92903 05011</a>
              </li>
              <li className="text-[#9A9A9A] text-[13px] leading-relaxed pt-2">
                Chenoy Trade Centre, Park Lane,<br />
                Secunderabad, Hyderabad — 500003
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-[#9A9A9A]/12 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-[11px] tracking-[0.25em] uppercase text-[#9A9A9A] font-btn">
            © {new Date().getFullYear()} DB Computronics. All rights reserved.
          </div>
          <div className="text-[11px] tracking-[0.25em] uppercase text-[#9A9A9A] font-btn">
            Enterprise IT · Networking · Surveillance · Power · Print
          </div>
        </div>
      </div>
    </footer>
  );
}
